module.exports = __webpack_public_path__ + "img/menu-icon.c4007822.svg";